import { Link, useLocation } from "react-router-dom";
import { LayoutGrid, PhoneCall, PhoneOutgoing, ListChecks, BarChart3, Settings2, Headset } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { hasPerm } from "@/lib/perms";

const TABS = [
  { to: "/shally", label: "Overview", icon: LayoutGrid, perm: "calls.view", id: "overview" },
  { to: "/shally/calls", label: "Calls", icon: PhoneCall, perm: "calls.view", id: "calls" },
  { to: "/shally/follow-ups", label: "Leads & Follow-ups", icon: ListChecks, perm: "calls.view", id: "follow-ups" },
  { to: "/shally/business-calling", label: "Business calling", icon: PhoneOutgoing, perm: "calls.outbound", id: "business-calling" },
  { to: "/settings/ai-receptionist/reports", label: "Analytics", icon: BarChart3, perm: "settings.view", id: "analytics" },
  { to: "/settings/ai-receptionist", label: "Settings", icon: Settings2, perm: "settings.edit", id: "settings" },
];

const activeTab = (path) => TABS.filter((t) => path === t.to || path.startsWith(t.to + "/")).sort((a, b) => b.to.length - a.to.length)[0];

export function ShallyShell({ children }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const tabs = TABS.filter((t) => hasPerm(user, t.perm));
  const cur = activeTab(pathname);
  return (
    <div className="mx-auto w-full max-w-7xl" data-testid="shally-shell">
      <div className="mb-5 flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent text-accent-foreground"><Headset className="h-[18px] w-[18px]" /></span>
        <div>
          <h1 className="text-xl font-extrabold tracking-tight text-foreground" data-testid="shally-title">Shally</h1>
          <p className="text-xs text-muted-foreground">AI Receptionist</p>
        </div>
      </div>
      <nav className="mb-6 grid grid-cols-3 gap-1.5 sm:hidden" aria-label="Shally sections" data-testid="shally-tabs-mobile">
        {tabs.map((t) => {
          const on = cur?.to === t.to;
          return (
            <Link key={t.to} to={t.to} aria-current={on ? "page" : undefined} data-testid={`shally-mtab-${t.id}`}
              className={`flex min-h-11 flex-col items-center justify-center gap-0.5 rounded-lg border px-1 py-1.5 text-center text-[11px] leading-tight transition-colors ${on ? "border-primary/40 bg-accent font-semibold text-accent-foreground" : "border-border bg-card font-medium text-muted-foreground"}`}>
              <t.icon className="h-4 w-4" />{t.label}
            </Link>);
        })}
      </nav>
      <nav className="-mx-1 mb-6 hidden gap-1 overflow-x-auto border-b border-border px-1 sm:flex" aria-label="Shally sections" data-testid="shally-tabs">
        {tabs.map((t) => {
          const on = cur?.to === t.to;
          return (
            <Link key={t.to} to={t.to} aria-current={on ? "page" : undefined} data-testid={`shally-tab-${t.id}`}
              className={`-mb-px flex shrink-0 items-center gap-2 border-b-2 px-3 py-2.5 text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 ${on ? "border-primary font-semibold text-foreground" : "border-transparent font-medium text-muted-foreground hover:text-foreground"}`}>
              <t.icon className={`h-4 w-4 ${on ? "text-primary" : ""}`} />{t.label}
            </Link>);
        })}
      </nav>
      {children}
    </div>);
}
